export default __webpack_public_path__ + "static/media/rocket_anim_7.b61843ca.png";